var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button",attrs:{"to":"/opportunities","id":"back-buttom","tag":"button"}},[_c('b-icon',{attrs:{"icon":"arrow-alt-circle-left"}}),_vm._v("\n    Voltar\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }